import PivotResultSchema, { PivotResult } from '../schemas/PivotResultSchema'

export default function PivotResultVo(initData: unknown = {}): PivotResult {
  return PivotResultSchema.validateSync(initData)
}
